import React, { Component } from 'react';
import { loginActions } from '../../action/loginAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { appVariables } from '../../helpers/appVariables';
import { Helmet } from 'react-helmet';

class GameRule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ShowRule: 1
        }
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : GameRule</title>
                    <meta name="description" content="Gulf Ticket GameRule" />
                </Helmet>
                }
                <h2 className="headding1 padding-top-0">{t('lblGamesRules')}</h2>
                <div class="myAccTabs">
                    <ul>
                        <li onClick={() => { this.setState({ ShowRule: 1 }) }}><a className={this.state.ShowRule == 1 ? "active" : ""} >General</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 2 }) }}><a className={this.state.ShowRule == 2 ? "active" : ""} >PlayLotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 3 }) }}><a className={this.state.ShowRule == 3 ? "active" : ""} >MiniLotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 4 }) }}><a className={this.state.ShowRule == 4 ? "active" : ""} >FastLotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 5 }) }}><a className={this.state.ShowRule == 5 ? "active" : ""} >Millionaire Lotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 6 }) }}><a className={this.state.ShowRule == 6 ? "active" : ""} >Multimillion Lotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 7 }) }}><a className={this.state.ShowRule == 7 ? "active" : ""} >Super MegaMillion Lotto</a></li>
                        <li onClick={() => { this.setState({ ShowRule: 8 }) }}><a className={this.state.ShowRule == 8 ? "active" : ""} >Scratch Card</a></li>
                    </ul>
                    <div className='wrap1'>
                        <div class="staticCont">
                            {(this.state.ShowRule == 2 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>PLAY LOTTO STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Play Lotto</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 36</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 376,992</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$50,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 2,432</div>
                                                <div class="w-15">155</div>
                                                <div class="w-15">$50</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 81</div>
                                                <div class="w-15">4,650</div>
                                                <div class="w-15">$5</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 8.39</div>
                                                <div class="w-15">44,950</div>
                                                <div class="w-15">$0.50</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.4</div>
                                                <div class="w-15">157,325</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }
                            {(this.state.ShowRule == 3 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>MINI LOTTO STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Mini Lotto</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 39</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 575,757</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$100,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 3,386.81</div>
                                                <div class="w-15">170</div>
                                                <div class="w-15">$100</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 102.63</div>
                                                <div class="w-15">5,610</div>
                                                <div class="w-15">$1</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 9.62</div>
                                                <div class="w-15">59,840</div>
                                                <div class="w-15">$0.50</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.48</div>
                                                <div class="w-15">231,880</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div></>
                            }

                            {(this.state.ShowRule == 4 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>FAST LOTTO STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Fast Lotto</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 42</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 850,668</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$300,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 4,598.21</div>
                                                <div class="w-15">185</div>
                                                <div class="w-15">$300</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 127.73</div>
                                                <div class="w-15">6,660</div>
                                                <div class="w-15">$3</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 10.95</div>
                                                <div class="w-15">77,700</div>
                                                <div class="w-15">$1</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.58</div>
                                                <div class="w-15">330,225</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }

                            {(this.state.ShowRule == 5 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>MILLIONAIRE  LOTTO STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Millionaire  Lotto</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 46</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 1,370,754</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$1,000,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 6,686.60</div>
                                                <div class="w-15">205</div>
                                                <div class="w-15">$100</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 167.17</div>
                                                <div class="w-15">8,200</div>
                                                <div class="w-15">$10</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 12.86</div>
                                                <div class="w-15">106,600</div>
                                                <div class="w-15">$0.30</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.71</div>
                                                <div class="w-15">506,350</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }

                            {(this.state.ShowRule == 6 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>MULTI MILLION STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Multi Million</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 39</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">6</div>
                                                <div class="w-15">1 in 3,262,623</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$3,000,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 16,478</div>
                                                <div class="w-15">198</div>
                                                <div class="w-15">$3,000</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 411.95</div>
                                                <div class="w-15">7,920</div>
                                                <div class="w-15">$30</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 29.9</div>
                                                <div class="w-15">109,120</div>
                                                <div class="w-15">$3</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 5.32</div>
                                                <div class="w-15">613,800</div>
                                                <div class="w-15">$0.30</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.29</div>
                                                <div class="w-15">1,424,016</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }

                            {(this.state.ShowRule == 7 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>SUPER MEGA MILLION STRUCTURE</h2>
                                    <p class="padding-bottom-20"><b>Lottery Betting Event:</b> Super Mega Million</p>
                                    <p><b>Ball Pool Range:</b> Numbers drawn are from a pool of 1 to 49</p>
                                    <p><b>Underlying Lottery:</b> Gulfticket-hosted draw using Smartplay RNG and mechanical draw systems</p>
                                    <p><b>Underlying Lottery Operator:</b> Future I Tech System Ltd (licensed by the Gambling Control Authority, Samoa)</p>
                                    <p>If a lottery draw does not take place, or if no result is published or officially announced, all valid Bets on the affected Lottery Betting Event will remain active and will be automatically carried forward to the rescheduled draw. If there is no rescheduled draw, the Bets will stand for the next available relevant draw.</p>

                                    <div class="table">
                                        <ul class="transTble transTble2">
                                            <li>
                                                <div class="w-40 text-left">Prize Category</div>
                                                <div class="w-15 text-left">Balls Matched</div>
                                                <div class="w-15 text-left">Odds</div>
                                                <div class="w-15 text-left">No of Combinations</div>
                                                <div class="w-15 text-left">Prize Value (USD)</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type A</div>
                                                <div class="w-15">6</div>
                                                <div class="w-15">1 in 13,983,816</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">$25,000,000*</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type B</div>
                                                <div class="w-15">5</div>
                                                <div class="w-15">1 in 54,201</div>
                                                <div class="w-15">258</div>
                                                <div class="w-15">$25,000</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">4</div>
                                                <div class="w-15">1 in 1,032.40</div>
                                                <div class="w-15">13,545</div>
                                                <div class="w-15">$250</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">3</div>
                                                <div class="w-15">1 in 56.66</div>
                                                <div class="w-15">246,820</div>
                                                <div class="w-15">$25</div>
                                            </li>
                                            <li>
                                                <div class="w-40">Type C</div>
                                                <div class="w-15">2</div>
                                                <div class="w-15">1 in 7.55</div>
                                                <div class="w-15">1,851,150</div>
                                                <div class="w-15">$2</div>
                                            </li>
                                            <li>
                                                <div class="w-40">–</div>
                                                <div class="w-15">1</div>
                                                <div class="w-15">1 in 2.42</div>
                                                <div class="w-15">5,775,588</div>
                                                <div class="w-15">$0</div>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }

                            {(this.state.ShowRule == 8 || this.state.ShowRule == 1) &&
                                <>
                                    <h2 class="headding1 padding-top-0" style={{ marginTop: "20px" }}>SCHEDULE 2: Rules on Scratch Card Games</h2>
                                    <p>These Rules on Scratch Card Games form part of the Terms and Conditions of the User Agreement.</p>


                                    <h3 class="padding-bottom-20">INTRODUCTION</h3>
                                    <p>Gulfticket offers digital Scratch Card games powered by certified Random Number Generator (RNG) software. Players reveal hidden panels or symbols on a virtual card to win prizes based on predefined outcomes.</p>
                                    <p>Each Scratch Card game has its own game rules, payout table, and winning odds. Please refer to the individual game information page for details before playing.</p>
                                    <h3 class="padding-bottom-20">HOW TO PLAY</h3>
                                    <p>Users must have a verified Gulfticket account to participate in Scratch Card games.</p>
                                    <p>Players select a Scratch Card game, confirm the ticket price, and click or tap to reveal symbols.</p>
                                    <p>Prizes are awarded instantly if the symbols revealed meet the criteria specified in the game’s win table.</p>
                                    <p>The outcome of a Scratch Card is determined at the moment of purchase using RNG systems certified for fairness and compliance.</p>
                                    <h3 class="padding-bottom-20">PRIZE STRUCTURE</h3>
                                    <span>Each Scratch Card game may include one or more of the following prize tiers:</span>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Jackpot Prize – the highest possible payout on the card </li>
                                            <li>Fixed Cash Prizes – secondary tier payouts</li>
                                            <li>Free Card Prizes – non-cash rewards such as a free card or game credit </li>
                                        </ul>
                                    </div>
                                    <p>Odds, prize values, and availability may vary by game and are shown in the game info section.</p>

                                    <h3 class="padding-bottom-20">GAME FAIRNESS AND VALIDATION</h3>
                                    <p>All Scratch Card outcomes are generated through a secure and tested RNG system.</p>
                                    <p>In case of technical interruption or suspected malfunction, Gulfticket reserves the right to invalidate the session and refund the ticket price.</p>

                                    <h3 class="padding-bottom-20">RESPONSIBLE PLAY</h3>
                                    <p>Scratch Cards are intended as casual entertainment. We encourage users to set deposit or session limits via the Responsible Gaming settings.</p>
                                    <p>If any user is found to be abusing the system, using bots or scripts, or participating fraudulently, Gulfticket may suspend their account and void winnings.</p>
                                    <p>Below are official prize tables for upcoming scratch card games. These reflect payout distribution, sample numbers, and winning conditions. Game names will be finalized before public launch.</p>

                                    <h3 class="padding-bottom-20" >Scratch Card Game 1 – (Suggested Name: Golden Match)</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.30</li>
                                            <li>Tickets Issued: 30,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Prize Amount (USD)</div>
                                                    <div class="w-15 text-left">Number of Winners</div>
                                                    <div class="w-15 text-left">Match Type</div>
                                                    <div class="w-15 text-left">Sample Numbers</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$2,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">641</div>
                                                    <div class="w-15">$2,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$300</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">149</div>
                                                    <div class="w-15">$600</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$30</div>
                                                    <div class="w-15">10</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">321, 492</div>
                                                    <div class="w-15">$300</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$0.75</div>
                                                    <div class="w-15">2,000</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">11, 37, 44, 79, 85</div>
                                                    <div class="w-15">$1,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$0.50</div>
                                                    <div class="w-15">5,500</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">33, 54, 68, 88, 92</div>
                                                    <div class="w-15">$2,750</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Scratch Card Game 2 – (Suggested Name: Treasure Ticket)</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.50</li>
                                            <li>Tickets Issued: 30,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Prize Amount (USD)</div>
                                                    <div class="w-15 text-left">Number of Winners</div>
                                                    <div class="w-15 text-left">Match Type</div>
                                                    <div class="w-15 text-left">Sample Numbers</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$3,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">827</div>
                                                    <div class="w-15">$3,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$30</div>
                                                    <div class="w-15">15</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">148, 567</div>
                                                    <div class="w-15">$450</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$5,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">11, 13, 34, 51, 72</div>
                                                    <div class="w-15">$5,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$0.50</div>
                                                    <div class="w-15">6,000</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">26, 46, 66, 85, 98</div>
                                                    <div class="w-15">$3,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Scratch Card Game 3 – (Suggested Name: Lucky One)</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.00</li>
                                            <li>Tickets Issued: 30,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Prize Amount (USD)</div>
                                                    <div class="w-15 text-left">Number of Winners</div>
                                                    <div class="w-15 text-left">Match Type</div>
                                                    <div class="w-15 text-left">Sample Numbers</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$10,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">567</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$100</div>
                                                    <div class="w-15">10</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">258, 937</div>
                                                    <div class="w-15">$1,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1.50</div>
                                                    <div class="w-15">4,000</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">124, 421</div>
                                                    <div class="w-15">$6,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1</div>
                                                    <div class="w-15">5,000</div>
                                                    <div class="w-15">2-digit</div>
                                                    <div class="w-15">26, 46, 66, 85, 98</div>
                                                    <div class="w-15">$5,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Scratch Card Game 4 – (Suggested Name: Super Scratch10)</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.50</li>
                                            <li>Tickets Issued: 30,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Prize Amount (USD)</div>
                                                    <div class="w-15 text-left">Number of Winners</div>
                                                    <div class="w-15 text-left">Match Type</div>
                                                    <div class="w-15 text-left">Sample Numbers</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$10,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">567</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1,000</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">121, 137, 316</div>
                                                    <div class="w-15">$3,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$100</div>
                                                    <div class="w-15">15</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">442, 505, 721</div>
                                                    <div class="w-15">$1,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$75</div>
                                                    <div class="w-15">15</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">220, 641, 820</div>
                                                    <div class="w-15">$1,125</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$50</div>
                                                    <div class="w-15">30</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">507, 779, 890</div>
                                                    <div class="w-15">$1,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$25</div>
                                                    <div class="w-15">100</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">774, 889, 909</div>
                                                    <div class="w-15">$2,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$5</div>
                                                    <div class="w-15">1,000</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">420, 566, 797</div>
                                                    <div class="w-15">$5,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1.50</div>
                                                    <div class="w-15">6,500</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">160, 206, 309</div>
                                                    <div class="w-15">$9,750</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Scratch Card Game 5 – (Suggested Name: Dream Match)</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.00</li>
                                            <li>Tickets Issued: 30,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Prize Amount (USD)</div>
                                                    <div class="w-15 text-left">Number of Winners</div>
                                                    <div class="w-15 text-left">Match Type</div>
                                                    <div class="w-15 text-left">Sample Numbers</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$10,000</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">111</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$500</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">269, 420, 925</div>
                                                    <div class="w-15">$1,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$150</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">142, 327, 620</div>
                                                    <div class="w-15">$450</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$100</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">459, 661, 725</div>
                                                    <div class="w-15">$300</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$75</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">121, 552, 823</div>
                                                    <div class="w-15">$225</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$50</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">332, 441, 823</div>
                                                    <div class="w-15">$150</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$2.50</div>
                                                    <div class="w-15">100</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">767, 892, 903</div>
                                                    <div class="w-15">$250</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1</div>
                                                    <div class="w-15">6,000</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">113, 212, 517</div>
                                                    <div class="w-15">$6,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">$1</div>
                                                    <div class="w-15">$3,000</div>
                                                    <div class="w-15">3-digit</div>
                                                    <div class="w-15">501, 622, 702, 802</div>
                                                    <div class="w-15">$3,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Christmas/Santa</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.30</li>
                                            <li>Tickets Issued: 5,000,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                    {/* <div class="w-15 text-left">Ticket Price</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$24,000</div>
                                                    <div class="w-15">$24,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">$2,400</div>
                                                    <div class="w-15">$4,800</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">100</div>
                                                    <div class="w-15">$240</div>
                                                    <div class="w-15">$24,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">500</div>
                                                    <div class="w-15">$30</div>
                                                    <div class="w-15">$15,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">5,000</div>
                                                    <div class="w-15">$6</div>
                                                    <div class="w-15">$30,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">50,000</div>
                                                    <div class="w-15">$2.10</div>
                                                    <div class="w-15">$105,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">100,000</div>
                                                    <div class="w-15">$1.20</div>
                                                    <div class="w-15">$120,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">200,000</div>
                                                    <div class="w-15">$0.90</div>
                                                    <div class="w-15">$180,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">450,000</div>
                                                    <div class="w-15">$0.30</div>
                                                    <div class="w-15">$135,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">900,000</div>
                                                    <div class="w-15">$0.15</div>
                                                    <div class="w-15">$135,000</div>
                                                    {/* <div class="w-15">$0.30</div> */}
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Cricket Hatrick</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.15</li>
                                            <li>Tickets Issued: 130,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                    {/* <div class="w-15 text-left">Ticket Price</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$1,500</div>
                                                    <div class="w-15">$1,500</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">$500</div>
                                                    <div class="w-15">$1,000</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">4</div>
                                                    <div class="w-15">$200</div>
                                                    <div class="w-15">$800</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">7</div>
                                                    <div class="w-15">$100</div>
                                                    <div class="w-15">$700</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">35</div>
                                                    <div class="w-15">$10</div>
                                                    <div class="w-15">$350</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">150</div>
                                                    <div class="w-15">$5</div>
                                                    <div class="w-15">$750</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">600</div>
                                                    <div class="w-15">$2</div>
                                                    <div class="w-15">$1,200</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">2,000</div>
                                                    <div class="w-15">$1</div>
                                                    <div class="w-15">$2,000</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">12,000</div>
                                                    <div class="w-15">$0.25</div>
                                                    <div class="w-15">$3,000</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">22,000</div>
                                                    <div class="w-15">$0.05</div>
                                                    <div class="w-15">$1,100</div>
                                                    {/* <div class="w-15">$0.15</div> */}
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Pet Race</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.10</li>
                                            <li>Tickets Issued: 100,000</li>
                                        </ul>

                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                    {/* <div class="w-15 text-left">Ticket Price</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$1,000</div>
                                                    <div class="w-15">$1,000</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">$200</div>
                                                    <div class="w-15">$400</div>
                                                    {/* <div class="w-15">$/0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">3</div>
                                                    <div class="w-15">$100</div>
                                                    <div class="w-15">$300</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">4</div>
                                                    <div class="w-15">$50</div>
                                                    <div class="w-15">$200</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">15</div>
                                                    <div class="w-15">$20</div>
                                                    <div class="w-15">$300</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">100</div>
                                                    <div class="w-15">$2</div>
                                                    <div class="w-15">$200</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">700</div>
                                                    <div class="w-15">$0.50</div>
                                                    <div class="w-15">$350</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">3,750</div>
                                                    <div class="w-15">$0.30</div>
                                                    <div class="w-15">$1,125</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">8,500</div>
                                                    <div class="w-15">$0.10</div>
                                                    <div class="w-15">$850</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">15,000</div>
                                                    <div class="w-15">$0.02</div>
                                                    <div class="w-15">$300</div>
                                                    {/* <div class="w-15">$0.10</div> */}
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Valentines Day</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $0.50</li>
                                            <li>Tickets Issued: 7,000,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$50,000</div>
                                                    <div class="w-15">$50,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">$5,000</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">15</div>
                                                    <div class="w-15">$500</div>
                                                    <div class="w-15">$7,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">150</div>
                                                    <div class="w-15">$50</div>
                                                    <div class="w-15">$7,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">4,000</div>
                                                    <div class="w-15">$10</div>
                                                    <div class="w-15">$40,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">16,000</div>
                                                    <div class="w-15">$5</div>
                                                    <div class="w-15">$80,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">90,000</div>
                                                    <div class="w-15">$2</div>
                                                    <div class="w-15">$180,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">350,000</div>
                                                    <div class="w-15">$1.50</div>
                                                    <div class="w-15">$525,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">700,000</div>
                                                    <div class="w-15">$0.75</div>
                                                    <div class="w-15">$525,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">1,300,000</div>
                                                    <div class="w-15">$0.25</div>
                                                    <div class="w-15">$325,000</div>
                                                </li>
                                            </ul>
                                        </div>


                                    </div>

                                    <h3 class="padding-bottom-20">Charity</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.00</li>
                                            <li>Tickets Issued: 2,000,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$50,000</div>
                                                    <div class="w-15">$50,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">16</div>
                                                    <div class="w-15">$500</div>
                                                    <div class="w-15">$8,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">400</div>
                                                    <div class="w-15">$25</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">1,000</div>
                                                    <div class="w-15">$10</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">1,000</div>
                                                    <div class="w-15">$6</div>
                                                    <div class="w-15">$6,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">4,000</div>
                                                    <div class="w-15">$5</div>
                                                    <div class="w-15">$20,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">20,000</div>
                                                    <div class="w-15">$4</div>
                                                    <div class="w-15">$80,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">64,000</div>
                                                    <div class="w-15">$2.50</div>
                                                    <div class="w-15">$160,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">32,000</div>
                                                    <div class="w-15">$2</div>
                                                    <div class="w-15">$64,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">168,000</div>
                                                    <div class="w-15">$1.50</div>
                                                    <div class="w-15">$252,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">11</div>
                                                    <div class="w-15">240,000</div>
                                                    <div class="w-15">$1</div>
                                                    <div class="w-15">$240,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">12</div>
                                                    <div class="w-15">200,000</div>
                                                    <div class="w-15">$0.50</div>
                                                    <div class="w-15">$100,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Happy Birthday</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.00</li>
                                            <li>Tickets Issued: 2,000,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$10,000</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">2</div>
                                                    <div class="w-15">$5,000</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">5</div>
                                                    <div class="w-15">$2,500</div>
                                                    <div class="w-15">$12,500</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">10</div>
                                                    <div class="w-15">$500</div>
                                                    <div class="w-15">$5,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">100</div>
                                                    <div class="w-15">$100</div>
                                                    <div class="w-15">$10,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">1,000</div>
                                                    <div class="w-15">$25</div>
                                                    <div class="w-15">$25,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">10,000</div>
                                                    <div class="w-15">$5</div>
                                                    <div class="w-15">$50,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">100,000</div>
                                                    <div class="w-15">$3</div>
                                                    <div class="w-15">$300,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">250,000</div>
                                                    <div class="w-15">$1</div>
                                                    <div class="w-15">$250,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Gold Bar</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $1.00</li>
                                            <li>Tickets Issued: 10,000,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$100,000.00</div>
                                                    <div class="w-15">$100,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">5</div>
                                                    <div class="w-15">$10,000.00</div>
                                                    <div class="w-15">$50,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">25</div>
                                                    <div class="w-15">$1,000.00</div>
                                                    <div class="w-15">$25,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">50</div>
                                                    <div class="w-15">$500.00</div>
                                                    <div class="w-15">$25,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">500</div>
                                                    <div class="w-15">$100.00</div>
                                                    <div class="w-15">$50,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">5,000</div>
                                                    <div class="w-15">$50.00</div>
                                                    <div class="w-15">$250,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">25,000</div>
                                                    <div class="w-15">$10.00</div>
                                                    <div class="w-15">$250,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">255,000</div>
                                                    <div class="w-15">$5.00</div>
                                                    <div class="w-15">$1,275,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">1,000,000</div>
                                                    <div class="w-15">$2.00</div>
                                                    <div class="w-15">$2,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">3,000,000</div>
                                                    <div class="w-15">Freeplay</div>
                                                    <div class="w-15">$3,000,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <h3 class="padding-bottom-20">Crorepati/Millionaire</h3>
                                    <div class="staticContLi">
                                        <ul>
                                            <li>Ticket Price: $4.00</li>
                                            <li>Tickets Issued: 50,000,000</li>
                                        </ul>
                                        <div class="table">
                                            <ul class="transTble transTble2">
                                                <li>
                                                    <div class="w-40 text-left">Tier</div>
                                                    <div class="w-15 text-left">Combinations</div>
                                                    <div class="w-15 text-left">Prize Value (USD)</div>
                                                    <div class="w-15 text-left">Total Payout (USD)</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">1</div>
                                                    <div class="w-15">1</div>
                                                    <div class="w-15">$1,000,000.00</div>
                                                    <div class="w-15">$1,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">2</div>
                                                    <div class="w-15">10</div>
                                                    <div class="w-15">$10,000.00</div>
                                                    <div class="w-15">$100,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">3</div>
                                                    <div class="w-15">150</div>
                                                    <div class="w-15">$2,000.00</div>
                                                    <div class="w-15">$300,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">4</div>
                                                    <div class="w-15">2,000</div>
                                                    <div class="w-15">$200.00</div>
                                                    <div class="w-15">$400,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">5</div>
                                                    <div class="w-15">60,000</div>
                                                    <div class="w-15">$40.00</div>
                                                    <div class="w-15">$2,400,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">6</div>
                                                    <div class="w-15">200,000</div>
                                                    <div class="w-15">$24.00</div>
                                                    <div class="w-15">$4,800,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">7</div>
                                                    <div class="w-15">200,000</div>
                                                    <div class="w-15">$20.00</div>
                                                    <div class="w-15">$4,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">8</div>
                                                    <div class="w-15">500,000</div>
                                                    <div class="w-15">$12.00</div>
                                                    <div class="w-15">$6,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">9</div>
                                                    <div class="w-15">500,000</div>
                                                    <div class="w-15">$10.00</div>
                                                    <div class="w-15">$5,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">10</div>
                                                    <div class="w-15">4,500,000</div>
                                                    <div class="w-15">$8.00</div>
                                                    <div class="w-15">$36,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">11</div>
                                                    <div class="w-15">3,000,000</div>
                                                    <div class="w-15">$6.00</div>
                                                    <div class="w-15">$18,000,000</div>
                                                </li>
                                                <li>
                                                    <div class="w-40">12</div>
                                                    <div class="w-15">6,000,000</div>
                                                    <div class="w-15">$5.00</div>
                                                    <div class="w-15">$30,000,000</div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </>
                            }


                        </div >
                    </div>
                </div >
            </>
        )
    }
}
function mapStateToProps(state) {
    const { user } = state.loginReducer;
    return { user };
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(GameRule))